enum TipoDeEvento {
    SaidaDeCanal = "channel_leave",
    EntradaDeCanal = "channel_join"
}

export function ehMensagemIgnorada(mensagem: { subtype: TipoDeEvento; }) {
    const tiposIgnorados = [TipoDeEvento.EntradaDeCanal, TipoDeEvento.SaidaDeCanal];
    return tiposIgnorados.includes(mensagem.subtype);
}
